const SHOPIFY_CDN_HOST = 'cdn.shopify.com';
function isShopifyImageUrl(url) {
    return url.hostname === SHOPIFY_CDN_HOST || url.pathname.includes('/cdn/shop/files/');
}
function parseShopifyImageUrl(source) {
    try {
        const url = new URL(source);
        return isShopifyImageUrl(url) ? url : undefined;
    }
    catch (_a) {
        return undefined;
    }
}
/**
 * Requests a CDN rendition without changing non-Shopify media URLs (including video).
 */
export function getShopifyImageUrl(source, width) {
    if (!source)
        return source;
    const url = parseShopifyImageUrl(source);
    if (!url)
        return source;
    try {
        url.searchParams.set('width', String(width));
        return url.toString();
    }
    catch (_a) {
        return source;
    }
}
export function getShopifyImageSrcSet(source, widths) {
    if (!source)
        return undefined;
    if (!parseShopifyImageUrl(source))
        return undefined;
    const sources = widths
        .map(width => {
        const url = getShopifyImageUrl(source, width);
        return url && `${url} ${width}w`;
    })
        .filter((source) => Boolean(source));
    return sources.length ? sources.join(', ') : undefined;
}
